function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { nanoid } from "nanoid";
/**
 * https://github.com/tldraw/tldraw/blob/d683cc09432197e89bddacf2b706b5eaad40e399/packages/tlschema/src/records/TLShape.ts
 *
 * Changes:
 * 	- Commented out everything but a couple methods
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { StyleProp } from "../legacy-styles/StyleProp";
import { createShapeValidator } from "../shapes/TLBaseShape";
// // evil type shit that will get deleted in the next PR
// type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
// 	? I
// 	: never
// type Identity<T> = { [K in keyof T]: T[K] }
// /** @public */
// export type TLShapeProps = Identity<UnionToIntersection<TLDefaultShape['props']>>
// /** @public */
// export type TLShapeProp = keyof TLShapeProps
// /** @public */
// export type TLParentId = TLPageId | TLShapeId
/** @internal */ export const rootShapeVersions = {
    AddIsLocked: 1,
    HoistOpacity: 2,
    AddMeta: 3
};
/** @internal */ export const rootShapeMigrations = defineMigrations({
    currentVersion: rootShapeVersions.AddMeta,
    migrators: {
        [rootShapeVersions.AddIsLocked]: {
            up: (record)=>{
                return _object_spread_props(_object_spread({}, record), {
                    isLocked: false
                });
            },
            down: (record)=>{
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { isLocked: _ } = record, rest = _object_without_properties(record, [
                    "isLocked"
                ]);
                return _object_spread({}, rest);
            }
        },
        [rootShapeVersions.HoistOpacity]: {
            up: (_param)=>{
                var { props: { opacity } } = _param, props = _object_without_properties(_param.props, [
                    "opacity"
                ]), record = _object_without_properties(_param, [
                    "props"
                ]);
                return _object_spread_props(_object_spread({}, record), {
                    opacity: Number(opacity !== null && opacity !== void 0 ? opacity : "1"),
                    props
                });
            },
            down: (_param)=>{
                var { opacity } = _param, record = _object_without_properties(_param, [
                    "opacity"
                ]);
                return _object_spread_props(_object_spread({}, record), {
                    props: _object_spread_props(_object_spread({}, record.props), {
                        opacity: opacity < 0.175 ? "0.1" : opacity < 0.375 ? "0.25" : opacity < 0.625 ? "0.5" : opacity < 0.875 ? "0.75" : "1"
                    })
                });
            }
        },
        [rootShapeVersions.AddMeta]: {
            up: (record)=>{
                return _object_spread_props(_object_spread({}, record), {
                    meta: {}
                });
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            down: (_param)=>{
                var { meta: _ } = _param, record = _object_without_properties(_param, [
                    "meta"
                ]);
                return _object_spread({}, record);
            }
        }
    }
});
/** @public */ export function isShape(record) {
    if (!record) return false;
    return record.typeName === "shape";
}
/** @public */ export function isShapeId(id) {
    if (!id) return false;
    return id.startsWith("shape:");
}
/** @public */ export function createShapeId(id) {
    return `shape:${id !== null && id !== void 0 ? id : nanoid()}`;
}
/** @internal */ export function getShapePropKeysByStyle(props) {
    const propKeysByStyle = new Map();
    for (const [key, prop] of Object.entries(props)){
        if (prop instanceof StyleProp) {
            if (propKeysByStyle.has(prop)) {
                throw new Error(`Duplicate style prop ${prop.id}. Each style prop can only be used once within a shape.`);
            }
            propKeysByStyle.set(prop, key);
        }
    }
    return propKeysByStyle;
}
/** @internal */ export function createShapeRecordType(shapes) {
    return createRecordType("shape", {
        migrations: defineMigrations({
            currentVersion: rootShapeMigrations.currentVersion,
            firstVersion: rootShapeMigrations.firstVersion,
            migrators: rootShapeMigrations.migrators,
            subTypeKey: "type",
            subTypeMigrations: mapObjectMapValues(shapes, (_, v)=>{
                var _v_migrations;
                return (_v_migrations = v.migrations) !== null && _v_migrations !== void 0 ? _v_migrations : defineMigrations({});
            })
        }),
        scope: "document",
        validator: T.model("shape", T.union("type", mapObjectMapValues(shapes, (type, { props, meta })=>createShapeValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            x: 0,
            y: 0,
            rotation: 0,
            isLocked: false,
            opacity: 1,
            meta: {}
        }));
}
